import { Box } from "@mui/material";
import FilmReleaseSelect from "components/common/FilmReleaseSelect";
import { log } from "loglevel";
import React from "react";
import { assertArray } from "../../core/validation";
import advertisingService from "../../services/advertisingService";
import Alert from "../common/Alert/Alert";
import ContactDropdown from "../common/Contacts";

const SelectFilmRelease = ({
    selectedFilmRelease,
    selectedContact,
    value,
    setValue,
    setSelectedFilmRelease,
    setSelectedContact,
    showWarning,
    selectProps = {}
}) => {
    const documentId = "SelectFilmReleaseId";

    async function handleOnChange(option, selectOptions) {
        if (option && option.value) {
            try {
                const { data: filmRelease } = await advertisingService.getFilmReleaseById(option.value);
                setSelectedFilmRelease(filmRelease);
                if (assertArray(filmRelease?.releaseContacts)) {
                    setSelectedContact(filmRelease.releaseContacts[0]);
                } else if (assertArray(filmRelease?.contacts)) {
                    setSelectedContact(filmRelease.contacts[0]);
                }
            } catch (err) {
                log.debug(err);
            }
        }

        if (selectOptions?.action === "clear") {
            setValue(null);
            setSelectedFilmRelease(null);
            setSelectedContact(null);
        } else {
            setValue(option);
        }
    }
    const handleOnChangeContacts = (arrayUser) => {
        setSelectedContact(assertArray(arrayUser) ? arrayUser[0] : null);
    };

    return (
        <Box>
            <div style={{ width: "100%" }}>
                <FilmReleaseSelect
                    value={value}
                    needsPortalHandler
                    selectPortalId={documentId}
                    onChange={handleOnChange}
                    defaultOptions={null}
                    {...selectProps}
                />
            </div>
            <Box mt={3}>
                {selectedFilmRelease?.contacts?.length > 0 && (
                    <ContactDropdown
                        isSingle
                        readOnly={false}
                        hideContactsPreview
                        showEmailFirst
                        value={selectedContact ? [selectedContact] : []}
                        onChange={handleOnChangeContacts}
                        options={selectedFilmRelease?.contacts || []}
                    />
                )}
            </Box>
            {showWarning && (
                <Box mt={4}>
                    <Alert severity="warning">You cant clone the to the same film release</Alert>
                </Box>
            )}
        </Box>
    );
};

export default SelectFilmRelease;
